import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {AmpelmannTextLogo, AmpelmannLogo} from '../../atoms';
import LeftNavBar from '../../molecules/SideBar';
import {colors} from '../../styles';
import IconButton from '@material-ui/core/IconButton';
import LogOutIcon from '../../atoms/LogOutIcon';
import {logoutUser} from '../../auth';
import GlobeIcon from '@material-ui/icons/Language';
import BuildIcon from '@material-ui/icons/Build';
import ListIcon from '@material-ui/icons/List';

const OCCSideBar = ({collapsed = true, children, history}) => {
  return collapsed
    ? (
      <LeftNavBar style={{backgroundColor: '#777e80', display: 'flex', flexDirection: 'column'}}>
        <div style={{background: colors.primary}}>
          <AmpelmannLogo style={{cursor: 'pointer'}} onClick={() => history.push('/')}/>
        </div>
        <SideBarButton onClick={() => history.location.pathname !== '/' && history.push('/')}>
          <ListIcon/>
        </SideBarButton>
        <SideBarButton onClick={() => history.location.pathname !== '/map' && history.push('/map')}>
          <GlobeIcon/>
        </SideBarButton>
        <SideBarButton onClick={() => history.location.pathname !== '/maintenances' && history.push('/maintenances')}>
          <BuildIcon/>
        </SideBarButton>
        {children}
        <SideBarButton
          aria-label="Logout"
          style={{marginTop: 'auto', marginBottom: '40px', marginLeft: '-10px'}}
          onClick={logoutUser}
        >
          <LogOutIcon />
        </SideBarButton>
      </LeftNavBar>
    )
    : (
      <LeftNavBar style={{flex: 0.15, minWidth: '240px', backgroundColor: '#777e80'}}>
        <AmpelmannTextLogo padding="20px 16px" />
        {children}
      </LeftNavBar>
    );
};

OCCSideBar.propTypes = {
  collapsed: PropTypes.bool,
  children: PropTypes.array,
  history: PropTypes.object
};

export default withRouter(OCCSideBar);

const SideBarButton = styled(IconButton)`
  color: white;
  border-radius: 0;
  .MuiSvgIcon-root {
    width: 35px;
    height: 35px;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.29);
  }
`;
